import DashboardSelection from 'components/AppService/HubSettings/Dashboard/DashboardSelection';
import DashboardSettings from 'components/AppService/HubSettings/Dashboard/DashboardSettings';
import { DefaultContentLayout } from '@timeedit/ui-components';

const HubDashboardSettingsPage = () => {
  return (
    <DefaultContentLayout
      title="Hub dashboard settings"
      subtitle="Dashboard configuration for hub users"
    >
      <div style={{ display: 'flex', height: '100%', marginTop: 10 }}>
        <DashboardSelection />
        <DashboardSettings />
      </div>
    </DefaultContentLayout>
  );
};

export default HubDashboardSettingsPage;
